import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  getCounterpartyRoleListService,
  getPermissionTableService,
  getScopeListService,
} from '../services/roles.service';
import { TPermissionTableResData, TScopeResData, TRolesListResData } from '../types/roles.types';

export const rbacQueryKeys = createQueryKeys(EQueryKeys.RbacQueryKeys, {
  getCounterpartyRoleList: (counterpartyGUID: string  ) => ({
    queryKey: ['get-counterparty-role-list', counterpartyGUID],
    queryFn: (): Promise<TRolesListResData> => getCounterpartyRoleListService(counterpartyGUID),
  }),
  getCounterpartyScopesList: (counterpartyGUID: string  ) => ({
    queryKey: ['get-counterparty-scopes-list', counterpartyGUID],
    queryFn: (): Promise<TScopeResData> => getScopeListService(counterpartyGUID),
  }),
  getPermissionTableData: (counterpartyGUID: string  ) => ({
    queryKey: ['get-permission-table-data', counterpartyGUID],
    queryFn: (): Promise<TPermissionTableResData> => getPermissionTableService(counterpartyGUID),
  }),
});
